import { initialState } from '@/Helpers.js';
import CourseEnrollment from '@/models/CourseEnrollment.js';

export const COURSE_ACTIVITY_REPORT = 'course activity report';
export const COURSE_GRADEBOOK_REPORT = 'course gradebook report';
export const COURSES_WITH_UNGRADED_SUBMISSIONS_REPORT = 'courses with ungraded submissions report';
export const MEETING_STATUS_REPORT = 'meeting status report';
export const LATE_OR_MISSED_MEETINGS_REPORT = 'late or missed meetings report';
export const FAILED_COURSE_REPORT = 'failed course report';
export const MISSING_SUBMISSIONS_REPORT = 'missing submissions report';
export const MISSING_COURSE_GRADES_REPORT = 'missing course grades report';
export const MEETING_COUNT_REPORT = 'meeting count report';
export const GROUP_COURSE_REPORT = 'group course report';
export const USER_ACTIVITY_REPORT = 'user activity report';
export const USER_IMPRESSIONS_REPORT = 'user impressions report';
export const GROUP_DISCUSSIONS_REPORT = 'group discussions report';
export const INSTRUCTOR_DISCUSSIONS_REPORT = 'instructor discussions report';
export const COURSE_SCHEMA_REPORT = 'course schema report';
export const COURSE_TEMPLATE_SCHEMA_REPORT = 'course template schema report';
export const RISK_ASSESSMENT_REPORT = 'risk assessment report';
export const COURSE_GRADES_REPORTS = 'course grades report';

export default class ReportPermissions {
    constructor(store, can) {
        this.reports = [
            COURSE_ACTIVITY_REPORT,
            COURSE_GRADEBOOK_REPORT,
            COURSES_WITH_UNGRADED_SUBMISSIONS_REPORT,
            MEETING_STATUS_REPORT,
            LATE_OR_MISSED_MEETINGS_REPORT,
            FAILED_COURSE_REPORT,
            MISSING_SUBMISSIONS_REPORT,
            MISSING_COURSE_GRADES_REPORT,
            MEETING_COUNT_REPORT,
            GROUP_COURSE_REPORT,
            USER_ACTIVITY_REPORT,
            USER_IMPRESSIONS_REPORT,
            GROUP_DISCUSSIONS_REPORT,
            INSTRUCTOR_DISCUSSIONS_REPORT,
            COURSE_SCHEMA_REPORT,
            COURSE_TEMPLATE_SCHEMA_REPORT,
            RISK_ASSESSMENT_REPORT,
        ];

        this.store = store;
        this.user = store.getters['Auth/user'];
        this.can = can;
        this.route = store.state.Route;

        this.allReportsEnabled = false;
        this.instructorReportsEnabled = false;
    }

    static loadUserEnrollments() {
        const userEnrollments = initialState('UserEnrollments', []);

        return CourseEnrollment.insert({ data: userEnrollments });
    }

    async register() {
        await ReportPermissions.loadUserEnrollments();

        this.evaluateGroups();
    }

    evaluateGroups() {
        this.user.user_groups.forEach(userGroup => {
            if (userGroup.hasInstructorRole()) {
                this.can('view', GROUP_COURSE_REPORT);
            }
        });
    }

    enableInstructorReports() {
        if (this.instructorReportsEnabled) {
            return;
        }

        this.can('view', COURSE_ACTIVITY_REPORT);
        this.can('view', COURSE_GRADEBOOK_REPORT);
        this.can('view', COURSES_WITH_UNGRADED_SUBMISSIONS_REPORT);
        this.can('view', MEETING_STATUS_REPORT);
        this.can('view', LATE_OR_MISSED_MEETINGS_REPORT);
        this.can('view', FAILED_COURSE_REPORT);
        this.can('view', MEETING_COUNT_REPORT);
        this.can('view', GROUP_DISCUSSIONS_REPORT);
        this.can('view', INSTRUCTOR_DISCUSSIONS_REPORT);
        this.can('view', RISK_ASSESSMENT_REPORT);

        this.instructorReportsEnabled = true;
    }

    enableAccessToAllReports() {
        if (this.allReportsEnabled) {
            return;
        }

        this.reports.forEach(report => this.can('view', report));
        this.allReportsEnabled = true;
    }

    toArray() {
        const permissions = ['reports', ...this.reports];

        return permissions.map(permission => ({
            action: 'view',
            subject: permission,
        }));
    }
}
